import {
  MYEV_API_BASE,
  MYEV_AUTH_API_BASE,
  MYEV_MEMBER_HOME,
} from '../config.js';

import { notifyHandledException } from '../utils/errorLogger';

export function localized_myev_url(url) {
  if (!window.Shopify?.country) {
    return url;
  }

  return `${url}?countryCode=${window.Shopify?.country}`;
}

export const getUpgradeablePets = async () => {
  const requestUrl = `${MYEV_AUTH_API_BASE}/public/shopify/eligible-pets${window.location.search}`;

  const response = await fetch(requestUrl, {});

  if (response.status === 200) {
    try {
      return await response.json();
    } catch (e) {
      notifyHandledException(e);
      throw new Error(
        `An error has occurred while retrieving dogs. Please try again later. <a href="${localized_myev_url(
          MYEV_MEMBER_HOME
        )}">Back to my account.</a>`
      );
    }
  }

  throw new Error(
    `We are currently experiencing an error.
      <a href="${localized_myev_url(
        MYEV_MEMBER_HOME
      )}">Please go back to your account and try again</a>.
      If this error persists, please email us at <a href="mailto:howdy@embarkvet.com">howdy@embarkvet.com</a>.`
  );
};

export const getHealthListJSON = async () => {
  const response = await fetch(`${MYEV_API_BASE}/health-list`);

  return response.json();
};
